import {Controller} from "@hotwired/stimulus"
import "leaflet"
import "leaflet-css"

export default class extends Controller {
  static targets = ["container", "input"]

  connect() {
    this.marker = null;
    const button = document.createElement('button')
    button.innerHTML = '🌍'
    button.type = 'button'
    button.onclick = () => {
      console.log('clicked')
      // first ask for permission
      navigator.permissions.query({name: 'geolocation'}).then((result) => {
        if (result.state === 'granted') {
          console.log('granted')
        } else if (result.state === 'prompt') {
          console.log('prompt')
        } else if (result.state === 'denied') {
          console.log('denied')
        }
      })
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          this.inputTarget.value = `${position.coords.latitude}, ${position.coords.longitude}`
          this.inputTarget.dispatchEvent(new Event("change", { bubbles: true }));
          this.setToMarker(this.marker)
        })
      }
    }
    this.inputTarget?.after(button)
    this.initMap()
  }

  initMap() {
    import("leaflet").then( L => {
      this.map = L.map(this.containerTarget).setView([0, 0], 13);
      this.marker = L.marker([0, 0], {draggable: true, autoPan: true});
      this.marker.addTo(this.map);
      this.marker.on('dragend', (event) =>{
        const {lat, lng } = event.target.getLatLng();
        this.inputTarget.value = `${lat}, ${lng}`
      });
      var tiles = L.tileLayer('https://api.maptiler.com/maps/outdoor-v2/{z}/{x}/{y}.png?key=gnxcJuntvIiXEF2XFXLc', {
        // maxZoom: 19,
        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> & <a href="https://www.vecteezy.com/free-vector/backpack-icon">Backpack Icon Vectors by Vecteezy</a>'
      }).addTo(this.map);
      this.setToMarker(this.marker)
      this.inputTarget.addEventListener('change', () => this.setToMarker(this.marker))
  
      //
      // if(this.inputTarget.value) {
      //   this.map.setView([this.latitudeValue, this.longitudeValue], this.zoomValue);
      //   const [latitude, longitude] = this.inputTarget.value.split(',').map(parseFloat);
      //
      // }
    });
  }
  setToMarker(marker) {
    const [lat, lng] = this.inputTarget?.value.split(',').map(parseFloat);
    var newLatLng = new L.LatLng(lat, lng);
    marker.setLatLng(newLatLng);
    this.map.setView(newLatLng, 15);
  }
}
